// extracted by mini-css-extract-plugin
export var avatarContainer = "_fx-0";
export var avatarTypingWave = "_fx-i";
export var gray = "_fx-f";
export var green = "_fx-c";
export var icon = "_fx-9";
export var image = "_fx-1";
export var lg = "_fx-6";
export var md = "_fx-5";
export var presenceDot = "_fx-b";
export var red = "_fx-d";
export var sm = "_fx-4";
export var status = "_fx-a";
export var typingDot = "_fx-h";
export var typingPill = "_fx-g";
export var xl = "_fx-7";
export var xs = "_fx-3";
export var xxl = "_fx-8";
export var xxs = "_fx-2";
export var yellow = "_fx-e";